import { render, staticRenderFns } from "./CameraIconV2.vue?vue&type=template&id=00bed3a2"
import script from "./CameraIconV2.vue?vue&type=script&lang=js"
export * from "./CameraIconV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports